exports.key="wrddev_portal_key";
exports.algorithm="aes-256-cbc"; 